import React from "react";
import { Link } from "react-router-dom";
import { BOOKING_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";
import { PageHero, Eyebrow } from "@/components/site/Section";
import { PEPTIDE_GROUPS } from "@/lib/content";

const steps = [
  { n: "01", title: "Discuss Your Goals", desc: "Review your wellness, aesthetic, recovery, or weight-management goals with the provider." },
  { n: "02", title: "Review Health History", desc: "Your medical history, current medications, and treatment eligibility are reviewed before recommendations are made." },
  { n: "03", title: "Personalized Plan", desc: "If appropriate, a customized peptide or wellness plan is created with follow-up guidance." },
];

export default function Peptides() {
  return (
    <div data-testid="peptides-page">
      <PageHero
        eyebrow="Wellness & Optimization"
        title="Peptide Therapy"
        subtitle="Personalized wellness support designed around your goals, medical history, and provider guidance."
      />

      <section className="py-8 bg-[var(--cream-2)] border-b border-[var(--line)]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10 flex flex-wrap justify-center gap-4">
          <BookLink label="Peptides Book" href={BOOKING_URL} className="btn-gold rounded-full px-8 py-3.5">Book a Consultation</BookLink>
          <Link to="/contact" className="btn-outline-gold rounded-full px-8 py-3.5">Ask a Question</Link>
        </div>
      </section>

      <section className="py-20 bg-[var(--cream)]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10">
          <Eyebrow className="text-center mb-3">Seraphina Collective</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl text-[var(--charcoal)] text-center max-w-3xl mx-auto leading-tight">
            Targeted Wellness, Guided by Clinical Oversight
          </h2>
          <p className="text-[var(--charcoal-soft)] leading-relaxed mt-5 text-center max-w-2xl mx-auto">
            Peptide and injectable wellness options may support goals such as weight management, recovery, energy,
            skin wellness, and overall optimization. Availability is based on consultation, health history, and provider approval.
          </p>
          <div className="grid sm:grid-cols-2 gap-6 mt-12">
            {PEPTIDE_GROUPS.map((g) => (
              <div key={g.title} className="soft-card rounded-2xl p-7">
                <h3 className="font-display text-2xl text-[var(--charcoal)]">{g.title}</h3>
                <div className="flex flex-wrap gap-2 mt-4">
                  {g.items.map((i) => (
                    <span key={i} className="text-sm bg-[var(--cream-2)] text-[var(--charcoal)] rounded-full px-4 py-1.5 border border-[var(--line)]">{i}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-[var(--cream-2)] border-y border-[var(--line)]">
        <div className="max-w-[1100px] mx-auto px-5 lg:px-10">
          <Eyebrow className="text-center mb-3">How It Works</Eyebrow>
          <h2 className="font-display text-4xl sm:text-5xl text-[var(--charcoal)] text-center">Consultation First</h2>
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            {steps.map((s) => (
              <div key={s.n} className="soft-card rounded-2xl p-8">
                <p className="font-display text-5xl text-[var(--gold)]">{s.n}</p>
                <h3 className="font-display text-2xl text-[var(--charcoal)] mt-3">{s.title}</h3>
                <p className="text-sm text-[var(--charcoal-soft)] mt-2">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-[var(--cream)]">
        <div className="max-w-[800px] mx-auto px-5 lg:px-10 text-center">
          <h3 className="font-display text-3xl text-[var(--charcoal)]">Important Notice</h3>
          <p className="text-sm text-[var(--charcoal-soft)] leading-relaxed mt-4">
            Peptide therapy and wellness injections are offered based on provider evaluation and may not be
            appropriate for everyone. This page is for general informational purposes and does not replace medical
            advice, diagnosis, or treatment. Individual results vary.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mt-7">
            <BookLink label="Peptides Book Bottom" href={BOOKING_URL} className="btn-gold rounded-full px-8 py-3.5">Book Consultation</BookLink>
            <Link to="/financing" className="btn-outline-gold rounded-full px-8 py-3.5">View Financing</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
